import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const InputGroup = lazy(
    () => import(/* webpackChunkName: "input-group" */ '../../../shared/form/input-group')
);
const BirthDateGroup = lazy(
    () => import(/* webpackChunkName: "birth-date-group" */ '../../../shared/form/birth-date-group')
);
const BirthTimeGroup = lazy(
    () => import(/* webpackChunkName: "birth-time-group" */ '../../../shared/form/birth-time-group')
);
const LocationGroup = lazy(
    () => import(/* webpackChunkName: "location-group" */ '../../../shared/form/location-group')
);
const RadioGroup = lazy(
    () => import(/* webpackChunkName: "radio-group" */ '../../../shared/form/radio-group')
);
import { getBirthDate, getBirthTime, checkLocationData, states } from '../../../shared/util';
import { MediaQuery as MQ } from '../../../shared/media-query';
import _ from 'underscore';
import dayjs from 'dayjs';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = props.logged_in && props.profile
            ? this.populateState(props.profile)
            : this.populateState(null);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.profile != this.props.profile) {
            if (nextProps.profile) {
                this.setState(this.populateState(nextProps.profile));
            } else {
                this.setState(this.populateState(null));
            }
        }
    }

    render({
        logged_in,
        submitting,
    }, {
        birth_name,
        gender,
        birth_date,
        birth_date_month,
        birth_date_day,
        birth_date_year,
        birth_time,
        birth_time_hour,
        birth_time_minute,
        birth_time_ampm,
        birth_location,
    }) {
        return (
            <form onSubmit={this.submit} autoComplete='off' className='has-margin-15-top'>
                {this.renderByline()}
                <row>
                    <column className='is-12'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <InputGroup
                                type='text'
                                name='birth_name'
                                label='Name:'
                                placeholder='ENTER NAME'
                                value={birth_name.value}
                                error={birth_name.error}
                                onInput={this.setFormValues}
                                disabled={logged_in}
                            />
                        </Suspense>
                    </column>
                </row>
                <row className='has-margin-20-bottom'>
                    <column className='is-1 is-2-tablet-portrait is-2-mobile is-3-tiny is-aligned-center'>
                        <label>Gender:</label>
                    </column>
                    <column className='is-11 is-10-tablet-portrait is-10-mobile is-9-tiny is-aligned-center'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <RadioGroup
                                name='gender'
                                value='female'
                                checked={gender.value == 'female'}
                                onChange={this.setFormValues}
                                label='Female'
                                disabled={logged_in}
                            />
                        </Suspense>
                        <Suspense fallback={<div className='skeleton' />}>
                            <RadioGroup
                                name='gender'
                                value='male'
                                checked={gender.value == 'male'}
                                onChange={this.setFormValues}
                                label='Male'
                                disabled={logged_in}
                            />
                        </Suspense>
                    </column>
                </row>
                <Suspense fallback={<div className='skeleton' />}>
                    <BirthDateGroup
                        name='birth_date'
                        label='Birth Date:'
                        date={birth_date}
                        month={birth_date_month}
                        day={birth_date_day}
                        year={birth_date_year}
                        onChange={this.setFormValues}
                        disabled={logged_in}
                    />
                </Suspense>
                <Suspense fallback={<div className='skeleton' />}>
                    <BirthTimeGroup
                        name='birth_time'
                        label='Birth Time:'
                        time={birth_time}
                        hour={birth_time_hour}
                        minute={birth_time_minute}
                        ampm={birth_time_ampm}
                        onChange={this.setFormValues}
                        disabled={birth_time.existing || submitting}
                    />
                </Suspense>
                <row className='is-wrap'>
                    <column className='is-6 is-12-mobile has-padding-10-right-desktop has-padding-10-right-tablet'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <LocationGroup
                                prefix='birth'
                                label='Birth'
                                onChange={this.setFormValues}
                                data={birth_location}
                                disabled={birth_location.existing || submitting}
                            />
                        </Suspense>
                    </column>
                </row>
                <row>
                    <column className='is-12 has-text-center'>
                        <button
                            className='button-havelock-blue has-arrow'
                            onClick={this.submit}
                            disabled={submitting}
                            dangerouslySetInnerHTML={{
                                __html: submitting ? 'SUBMITTING…' : 'GET YOUR CHART',
                            }}
                        />
                        {this.renderFormError()}
                    </column>
                </row>
            </form>
        );
    }

    renderByline = () => {
        if (this.props.logged_in) {
            return [
                <p className='has-text-center'>
                    Reveal what makes you truly one-of-a-kind
                    <br className='is-hidden-mobile' /><span className='is-visible-mobile'>&nbsp;</span>with your
                    FREE Birth Chart Reading!
                </p>,
                <p className='has-text-center'>
                    These details are based on&nbsp;
                    <a
                        href='/member/settings/profiles-manager'
                        onClick={() => this.props.trackEvent([
                            'Birth Chart',
                            'Click',
                            'BC:Teeup:UpdateProfile',
                            'Readings_your-birth-chart:Teeup_UpdateProfile',
                        ])}
                    >
                        your profile
                    </a>.
                    <br className='is-hidden-mobile' /><span className='is-visible-mobile'>&nbsp;</span> Please add
                    your birth time (if known) and birth location:
                </p>,
            ];
        }

        return [
            <p className='has-text-center'>
                Reveal what makes you truly one-of-a-kind
                <br className='is-hidden-mobile' /><span className='is-visible-mobile'>&nbsp;</span>with your
                FREE Birth Chart Reading!
            </p>,
            <p className='has-text-center'>
                Already have an account?&nbsp;
                <a
                    href='#login'
                    onClick={() => this.props.trackEvent([
                        'Birth Chart',
                        'Click',
                        'BC:Teeup:Login',
                        'Readings_your-birth-chart:Teeup_LogIn',
                    ])}
                >
                    Log In Now
                </a>
            </p>,
        ];
    }

    renderFormError = () => {
        if (this.state.formError) {
            return (<p className='is-error has-margin-10-top'>Please check required fields above</p>);
        }

        return null;
    }

    populateState = (profile) => {
        let state = {
            birth_name: {
                value: '',
                error: null,
            },
            gender: {
                value: 'female',
            },
            birth_date: {
                value: '',
                error: null,
            },
            birth_date_month: {
                value: null,
                error: null,
            },
            birth_date_day: {
                value: null,
                error: null,
            },
            birth_date_year: {
                value: null,
                error: null,
            },
            birth_time: {
                value: null,
                error: null,
                existing: false,
            },
            birth_time_hour: {
                value: null,
                error: null,
            },
            birth_time_minute: {
                value: null,
                error: null,
            },
            birth_time_ampm: {
                value: 'am',
                error: null,
            },
            birth_location: {
                existing: false,
                country: {
                    value: null,
                    error: false,
                },
                state: {
                    value: null,
                    error: false,
                },
                city: {
                    value: null,
                    error: false,
                },
                city_id: {
                    value: null,
                },
            },
        };

        if (profile) {
            const birth_date = dayjs(profile.birth_date, 'YYYY-MM-DD');
            const birth_time = dayjs(profile.birth_time, 'HH:mm');
            Object.keys(profile).map(key => {
                profile[key] = profile[key] === null ? '' : profile[key];
            });

            if (profile.birth_city && profile.birth_country && !profile.birth_city_id) {
                this.props.getLocation({
                    prefix: 'birth',
                    city_name: profile.birth_city.toLowerCase().replace(' ', '_'),
                    state_name: profile.birth_state.toLowerCase(),
                    country_name: profile.birth_country.toLowerCase(),
                });
            } else if (profile.birth_city_id && !profile.birth_country_id) {
                this.props.getLocation({
                    prefix: 'birth',
                    city_id: profile.birth_city_id,
                });
            }

            state = {
                birth_name: {
                    value: profile.first_name || null,
                    error: null,
                },
                gender: {
                    value: profile.gender || 'female',
                },
                birth_date: {
                    value: birth_date.isValid() ? birth_date.format('YYYY-MM-DD') : null,
                    error: null,
                },
                birth_date_month: {
                    value: birth_date.isValid() ? birth_date.format('M') : null,
                    error: null,
                },
                birth_date_day: {
                    value: birth_date.isValid() ? birth_date.format('D') : null,
                    error: null,
                },
                birth_date_year: {
                    value: birth_date.isValid() ? birth_date.format('YYYY') : null,
                    error: null,
                },
                birth_time: {
                    value: profile.birth_time,
                    error: null,
                    existing: profile.birth_time,
                },
                birth_time_hour: {
                    value: profile.birth_time ? birth_time.format('h') : null,
                    error: null,
                },
                birth_time_minute: {
                    value: profile.birth_time ? birth_time.format('mm') : null,
                    error: null,
                },
                birth_time_ampm: {
                    value: profile.birth_time ? birth_time.format('a') : 'am',
                    error: null,
                },
                birth_location: {
                    existing: profile.birth_city_id,
                    country: {
                        value: profile.birth_country_id,
                        error: false,
                    },
                    state: {
                        value: profile.birth_state_id,
                        error: false,
                    },
                    city: {
                        value: profile.birth_city,
                        error: false,
                    },
                    city_id: {
                        value: profile.birth_city_id,
                    },
                },
            };
        }

        return state;
    }

    /* eslint-disable complexity */
    setFormValues = (e) => {
        let state = {};

        if ((e.type == 'keyup' && e.key == 'Enter') || e.type == 'change' || e.type == 'input') {
            if (e.target.type && e.target.type == 'checkbox') {
                if (e.target.checked) {
                    state[e.target.name] = { value: e.target.value, error: false };
                } else {
                    state[e.target.name] = { value: null, error: false };
                }
            } else if (['birth_location', 'current_location'].includes(e.target.name)) {
                state[e.target.name] = e.target.value;
            } else {
                state[e.target.name] = { value: e.target.value, error: false };
            }

            if (e.target.name == 'birth_date_month') {
                state.birth_date = {
                    value: getBirthDate(
                        e.target.value,
                        this.state.birth_date_day.value,
                        this.state.birth_date_year.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_date_day') {
                state.birth_date = {
                    value: getBirthDate(
                        this.state.birth_date_month.value,
                        e.target.value,
                        this.state.birth_date_year.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_date_year') {
                state.birth_date = {
                    value: getBirthDate(
                        this.state.birth_date_month.value,
                        this.state.birth_date_day.value,
                        e.target.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_date') {
                state.birth_date = {
                    value: dayjs(e.target.value).format('YYYY-MM-DD'),
                    error: false,
                };
            } else if (e.target.name == 'birth_time_hour') {
                state.birth_time = {
                    value: getBirthTime(
                        e.target.value,
                        this.state.birth_time_minute.value,
                        this.state.birth_time_ampm.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_time_minute') {
                state.birth_time = {
                    value: getBirthTime(
                        this.state.birth_time_hour.value,
                        e.target.value,
                        this.state.birth_time_ampm.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_time_ampm') {
                state.birth_time = {
                    value: getBirthTime(
                        this.state.birth_time_hour.value,
                        this.state.birth_time_minute.value,
                        e.target.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_time' && e.target.value == 'unknown') {
                state.birth_time_hour = {
                    value: null,
                    error: false,
                };

                state.birth_time_minute = {
                    value: null,
                    error: false,
                };
            }

            this.setState(state);
        }
    }

    submit = (e) => {
        e.preventDefault();
        this.props.trackEvent([
            'Birth Chart',
            'Click',
            'BC:Teeup:GetYourChart',
            'Readings_your-birth-chart:Teeup_GetYourChart',
        ]);
        this.setState({ formError: false });
        const state = { formError: false };

        if (!this.state.birth_name.value) {
            state.formError = true;
            state.birth_name = {
                value: null,
                error: 'This field is required',
            };
        }

        if (
            !this.state.birth_date.value
            ||
            !this.state.birth_date.value.toString().match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/)
        ) {
            state.formError = true;
            state.birth_date = {
                value: this.state.birth_date.value,
                error: 'This field is required',
            };

            if (!MQ.isMobile()) {
                if (!this.state.birth_date_month.value) {
                    state.birth_date_month = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!this.state.birth_date_day.value) {
                    state.birth_date_day = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!this.state.birth_date_year.value) {
                    state.birth_date_year = {
                        value: null,
                        error: 'This field is required',
                    };
                }
            }
        }

        if (!this.state.birth_time.value) {
            state.formError = true;
            state.birth_time = {
                value: null,
                error: 'This field is required',
            };

            if (!MQ.isMobile()) {
                if (!this.state.birth_time_hour.value) {
                    state.birth_time_hour = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!this.state.birth_time_minute.value) {
                    state.birth_time_minute = {
                        value: null,
                        error: 'This field is required',
                    };
                }
            }
        }


        state.birth_location = { ...this.state.birth_location };
        if (this.state.birth_location.country.value) {
            if (checkLocationData(this.props.location.birth_states, this.state.birth_location.state.value)) {
                state.formError = true;
                state.birth_location.state = {
                    value: this.state.birth_location.state.value,
                    error: 'This field is required',
                };
            }

            if (this.props.location.birth_cities && !this.state.birth_location.city.value) {
                state.formError = true;
                state.birth_location.city.error = 'This field is required';
            } else if (this.props.location.birth_cities && !this.state.birth_location.city_id.value) {
                state.formError = true;
                state.birth_location.city.error = 'A valid city is required';
            }
        } else {
            state.formError = true;
            state.birth_location.country.error = 'This field is required';
        }

        if (!state.formError) {
            const prefix = this.props.view && this.props.view == 2 ? 'person_2' : 'person_1';
            const state = this.state; //locking in values, so forced login won't change them

            const birth_state = state.birth_location.country.value == 5022
                ? _.invert(states.USA)[this.props.location.birth_states[state.birth_location.state.value]]
                : null;

            const payload = {
                [`${prefix}_name`]: {
                    first: state.birth_name.value,
                },
                [`${prefix}_birth_date`]: state.birth_date.value,
                [`${prefix}_birth_location`]: {
                    city: state.birth_location.city.value,
                    state: birth_state,
                    country: this.props.location.birth_country.name,
                    city_id: state.birth_location.city_id.value,
                },
            };

            payload.gender = state.gender.value;

            if (state.birth_time.value !== 'unknown') {
                payload[`${prefix}_birth_time`] = state.birth_time.value;
            }

            this.props.submit(payload);
        } else {
            this.setState({ ...this.state, ...state });
        }
    }
    /* eslint-enable complexity */
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    profile: state.user && state.user.selected_profile,
    submitting: state.product && state.product.submitting,
    location: state.location,
});

const mapDispatchToProps = (dispatch) => ({
    getLocation: (payload) => dispatch({ type: 'product:get-location', payload: payload }),
    submit: (payload) => dispatch({ type: 'report:submit', payload: payload }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
